import { UseMutateAsyncFunction } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { getNetworkElementVesDuPath } from '@api/networkElements';

import { IId } from '@interfaces/common/common';
import { IPath } from '@interfaces/networkElements/networkElements';

import { NETWORK_ELEMENTS_VES_DU_PATH } from '@constants/queryKeys';

interface IUseMutateNetworkElementsGetVesPathDuReturned {
	getPathDu: UseMutateAsyncFunction<any, any, IId<string>, any>;
	isLoadingGetPathDu: boolean;
	vesPathDu: IPath;
}

const useMutateNetworkElementsGetVesPathDu = (): IUseMutateNetworkElementsGetVesPathDuReturned => {
	const {
		mutateAsync,
		data,
		isLoading,
	} = useMutation<IId>({
		mutationKey: [NETWORK_ELEMENTS_VES_DU_PATH],
		mutationFn: getNetworkElementVesDuPath,
	});

	return {
		getPathDu: mutateAsync,
		vesPathDu: data,
		isLoadingGetPathDu: isLoading,
	};
};

export default useMutateNetworkElementsGetVesPathDu;
